import { render, staticRenderFns } from "./SettingsOtherProfiles.vue?vue&type=template&id=2226e096&scoped=true"
import script from "./SettingsOtherProfiles.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsOtherProfiles.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SettingsOtherProfiles.vue?vue&type=style&index=0&id=2226e096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226e096",
  null
  
)

export default component.exports